import SmoothScroll from 'smooth-scroll'

const headerHeight = document.querySelector('.header').offsetHeight

const scrollInstance = new SmoothScroll('a[href*="#"]', {
  speed: 300,
  ignore: '[href="#"]',
  offset() {
    return headerHeight + 20
  }
})
try {
  if (window.location.hash) {
    scrollInstance.animateScroll(document.querySelector(window.location.hash))
  }
} catch (err) { }